import { Injectable } from '@angular/core'

import { Rental } from './rental'

@Injectable()
export class RentalSerializer {
  fromJson(json: any): Rental {
    const rental = {
      ...json
    }

    return rental
  }

  toJson(rental: Rental): any {
    return {
      ...rental
    }
  }
}
